module.exports = __webpack_public_path__ + "306f6e7bcb9103e0c534308e04f06965.svg";